import { Layout, Menu, Dropdown, Drawer, BackTop, Avatar } from "antd";
import { Component } from "react";
import React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import Redirect from "./404";
import routes, { routes_ins_scanner, routes_ins_silizhu, routes_store_scanner, routes_store_silizhu } from "../../javascripts/routes";
import RouteWithSubRoutes from './routeWithSubRoutes'
import SiderNav from './siderNav';
import {
    LogoutOutlined,
    MenuUnfoldOutlined,
    MenuFoldOutlined,
} from '@ant-design/icons';
import { RootState } from "../../core/reducers";
import { ThunkDispatch } from "redux-thunk";
import { AnyAction } from "redux";
import { connect } from "react-redux";
import { actionLogoutSuccess } from "../../core/actions/user";
import { actionChangeCollapsed } from "../../core/actions/style";
import './public.css'
import './index.css'
import './print.css'
import Breadcrumb from './breadcrumb'
import icon_person from './images/icon_person.png'
import icon_back from './images/icon_back.png'
import { LoginDevice } from "../../javascripts/public";

interface StateProps {
    orgInfo: any
    collapsed: boolean
    menuData: any[],
    loginDevice: LoginDevice | string
    routeKey: string
}

interface DispatchProps {
    changeCollapsed(collapsed: boolean): void
    logout(): void
}

const { Header, Content, Footer } = Layout;
const MenuItem = Menu.Item;

type PropsType = RouteComponentProps & StateProps;
class MainContent extends Component<PropsType & DispatchProps> {

    toggle = () => {
        let ua = navigator.userAgent.toLocaleLowerCase();
        let isMobile = /mobi/i.test(ua);
        if (isMobile) {
            this.showDrawer();
        }
        else {
            let collapsed = !this.props.collapsed;
            this.props.changeCollapsed(collapsed);
        }
    }

    isHasPath = () => {
        const { history } = this.props;
        let pathname = history.location.pathname;
        let menuData = this.props.menuData || [];
        let flag = false;
        menuData.map((item) => {
            if (item.children) {
                item.children.map((data) => {
                    if (pathname.search(data.key) !== -1) flag = true;
                })
            }
            else if (pathname.search(item.key) !== -1) {
                flag = true;
            }
        })
        return flag;
    }

    onClick = ({ key }) => {
        const { history } = this.props;
        let pathname = history.location.pathname;
        if (pathname.search('/institution') !== -1) {
            history.push('/institution/login');
        }
        else {
            history.push('/merchant/login');
        }
        localStorage.removeItem('accessToken');
        localStorage.removeItem('orgId');
        localStorage.removeItem('loginStatus');
        this.props.logout();

    }

    state = {
        visible: false,
    }

    showDrawer = () => {
        this.setState({
            visible: true
        })
    }

    onClose = () => {
        this.setState({
            visible: false,
        })
    }

    goBack = () => {
        const { history } = this.props;
        history.goBack();
    }

    returnRouteAll = () => {
        const { loginDevice, routeKey } = this.props;
        let routesAll: any[] = routes;
        if (routeKey === "institution") {
            if (loginDevice === LoginDevice.SCANNER) {
                routesAll = [
                    ...routesAll,
                    ...routes_ins_scanner,
                ]
            }
            else {
                routesAll = [
                    ...routesAll,
                    ...routes_ins_silizhu,
                ]
            }
        }
        else if(routeKey === "merchant") {
            if (loginDevice === LoginDevice.SCANNER) {
                routesAll = [
                    ...routesAll,
                    ...routes_store_scanner,
                ]
            }
            else {
                routesAll = [
                    ...routesAll,
                    ...routes_store_silizhu,
                ]
            }
        }

        return routesAll;
    }

    render() {

        let isNot404 = this.isHasPath();
        const menu = (
            <Menu onClick={this.onClick}>
                <MenuItem key="0"><LogoutOutlined />退出</MenuItem>
            </Menu>
        );

        let ua = navigator.userAgent.toLocaleLowerCase();
        let isMobile = /mobi/i.test(ua);
        const contentRef = React.createRef();
        let collapsed = this.props.collapsed;
        let orgInfo = this.props.orgInfo || {};
        let orgName = orgInfo.name;

        const { history } = this.props;
        let state = history.location.state;
        let pathname = history.location.pathname;
        let isLeap = pathname.search('/leap') !== -1 ? true : false;

        let routesAll: any[] = this.returnRouteAll();

        return (
            <Layout hasSider={false}>
                <div ref={contentRef as any} className='backtop'>
                    <Header className="header">
                        {
                            collapsed ?
                                <MenuUnfoldOutlined onClick={this.toggle} /> :
                                <MenuFoldOutlined onClick={this.toggle} />
                        }
                        {
                            orgInfo.validity === 0 && <span className="error-center">账号已过期</span>
                        }
                        <Dropdown overlay={menu}>
                            <a href="#">
                                <img src={icon_person} className="icon_person" />
                                <span className="header-right">{orgName}</span>
                            </a>
                        </Dropdown>
                        {
                            isMobile ?
                                <div className="drawer-sider-menu screen-xs">
                                    <Drawer
                                        width={216}
                                        placement="left"
                                        closable={false}
                                        onClose={this.onClose}
                                        visible={this.state.visible}
                                        className="drawer-sider-menu screen-xs"
                                    >
                                        <SiderNav />
                                    </Drawer>
                                </div> : null
                        }
                    </Header>
                    <Content>
                        {
                            !isNot404 ? <Redirect /> :
                                (
                                    <div className={state === 'back' && !isLeap ? "breadcrumb sticky" : "breadcrumb"}>
                                        {
                                            state === 'back' &&
                                            <img
                                                src={icon_back}
                                                className="breacrumb-back"
                                                onClick={() => this.goBack()}
                                            />
                                        }
                                        <Breadcrumb />
                                    </div>
                                )
                        }
                        <div>
                            {
                                routesAll.map((route, i) => {
                                    if (route.authorized) {
                                        if (!isNot404) return;
                                        return <RouteWithSubRoutes key={i}{...route} />
                                    }
                                    else return;
                                })
                            }
                        </div>
                    </Content>
                    <Footer>
                        Copyright © SennoFeet足压后台  2020-2050
                    </Footer>
                </div>
                <BackTop target={() => contentRef.current as any} />
            </Layout>
        )
    }
}


function mapStateToProps(state: RootState): StateProps {
    return {
        collapsed: state.style.collapsed,
        menuData: state.user.menuData,
        orgInfo: state.user.orgInfo,
        loginDevice: state.user.loginDevice,
        routeKey: state.user.routeKey,
    }
}

function mapDispatchToProps(dispatch: ThunkDispatch<RootState, null, AnyAction>): DispatchProps {
    return {
        changeCollapsed: (collapsed: boolean) => {
            dispatch(actionChangeCollapsed({
                collapsed: collapsed
            }))
        },
        logout: () => {
            dispatch(actionLogoutSuccess({}))
        },
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MainContent) as any)
